import React, { useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Button from "../../../../components/form/Button";
import useForm from "../../../../hooks/useForm";
import ManagePassword from "../../../../components/sections/admin/ChangePassword/ManagePassword";
import ChangeEmail from "../../../../components/ChangeEmail";
import ProfileComponent from "../../../../components/profile/Profile";
import { setPassword } from "../../../../services/authService";
import ImageUploader from "../../../../components/form/ImageUploader";
import { useQueryClient } from "@tanstack/react-query";

function Profile() {
  const [image, setImage] = useState();

  return (
    <div className="md:flex max-w-[1400px] m-auto bg-white border border-slate-300 rounded-md px-8 md:pr-8 gap-5 lg:gap-11 md:px-0">
      <div className="max-w-72 md:border-r border-slate-300 flex-shrink-0">
        <div className="text-xl font-semibold text-[#C94E53] pt-4 pb-4 border-b border-slate-300 text-center mb-10">
          Profile Photo
        </div>
        <div className="px-[36px]">
          <ImageUploader
            label=""
            isMultiple={false}
            isCrop={false}
            image={image}
            setImage={setImage}
            buttonLabel={image ? "Change Profile" : "Upload Profile"}
            buttonLabelClasses="!text-xs"
            labelClasses="text-lg font-bold"
            buttonIcon="fa-upload text-xs"
            buttonClasses="!px-1 !py-2 bg-blue-500 text-white rounded-lg hover:bg-red-600 mx-auto !h-auto !w-[94%]"
            inputClasses="hover:bg-slate-200 rounded-lg overflow-hidden border-slate-300 !border-2 shadow-lg"
          />
        </div>
      </div>
      <div className="w-full mt-10 md:mt-0">
        <h1 class="text-xl lg:text-2xl xls:text-3xl font-bold text-[#C94E53] py-4 rounded-2xl text-center md:text-left">
          Profile Information
        </h1>
        <ProfileComponent image={image} setImage={setImage} />
        <h1 class="text-xl lg:text-2xl xls:text-3xl font-bold text-[#C94E53] py-4 rounded-2xl text-center md:text-left">
          Change Password
        </h1>
        {/* {user?.isPassword ? 
        ( */}
        <ManagePassword />
        {/* ) 
        : (
          <form onSubmit={(event) => handleSubmit(event, () => {})}>
            <div className="relative col-span-4 mt-5">
              <div className="flex items-center justify-start gap-4">
                <Button
                  buttonType="submit"
                  buttonLabel={"Set Password"}
                  buttonLabelClasses={"!text-sm"}
                  buttonIcon={"fa-light fa-floppy-disk"}
                  buttonIconPosition={"left"}
                  buttonClasses="!py-2 !px-2 rounded-lg text-white !h-auto !bg-primary hover:!bg-red-600"
                  // {...(isLoading && {
                  //   loading: true,
                  //   buttonIconPosition: "left",
                  //   isDisable: true,
                  // })}
                />
              </div>
            </div>
          </form>
        )} */}

        {/* <h1 class="text-xl lg:text-2xl xls:text-3xl font-bold text-[#C94E53] py-4 rounded-2xl text-center md:text-left">
          Update Email
        </h1>
        <ChangeEmail /> */}
      </div>
    </div>
  );
}

export default Profile;
